import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.411 4.714l.4.8.005.01a6.002 6.002 0 002.67 2.655l.798.4a.57.57 0 01.286.687l-.28.859v.003c-.4 1.217-.4 2.53 0 3.748l.28.85.001.002a.566.566 0 01-.285.683l-.8.4-.01.005a6.001 6.001 0 00-2.655 2.67l-.4.798a.57.57 0 01-.686.286l-.86-.28h-.003c-1.217-.4-2.53-.4-3.748 0l-.85.28-.002.001a.566.566 0 01-.683-.285l-.4-.8-.005-.01a6.002 6.002 0 00-2.67-2.655l-.798-.4a.57.57 0 01-.286-.686l.28-.86v-.003c.4-1.217.4-2.53 0-3.748l-.28-.85-.001-.002a.566.566 0 01.285-.683l.8-.4.01-.005a6.001 6.001 0 002.655-2.67l.4-.798a.57.57 0 01.687-.286l.862.28c1.217.4 2.531.4 3.748 0l.852-.281a.566.566 0 01.683.285zM20.18 6.79l-.8-.4a4 4 0 01-1.78-1.77l-.4-.8a2.566 2.566 0 00-3.1-1.29l-.85.28a4 4 0 01-2.5 0l-.86-.28a2.57 2.57 0 00-3.1 1.29l-.4.8A4 4 0 014.62 6.4l-.8.4a2.566 2.566 0 00-1.29 3.1l.28.85a4 4 0 010 2.5l-.28.86a2.57 2.57 0 001.29 3.1l.8.4a4 4 0 011.78 1.77l.4.8a2.566 2.566 0 003.1 1.29l.85-.28a4 4 0 012.5 0l.86.28a2.57 2.57 0 003.1-1.29l.4-.8a4 4 0 011.77-1.78l.8-.4a2.566 2.566 0 001.29-3.1l-.28-.85a4 4 0 010-2.5l.28-.86a2.57 2.57 0 00-1.29-3.1zM7.83 9.188a1.438 1.438 0 112.876 0 1.438 1.438 0 01-2.877 0zm6.674-1.15a1.042 1.042 0 011.458 1.459l-.01.014-6.338 6.337a1.042 1.042 0 11-1.462-1.462l6.337-6.338.014-.01zm-1.13 6.695a1.438 1.438 0 112.876 0 1.438 1.438 0 01-2.876 0z",
      fill: "#2d6ded"
    }
  )
);
export {
  e as default
};
